// extracted by mini-css-extract-plugin
module.exports = {"radio":"CustomRadio_radio__2POU5","innerCircle":"CustomRadio_innerCircle__LjJHs","selected":"CustomRadio_selected__y2CRw","disabled":"CustomRadio_disabled__3nMck"};